<template>
  <v-app-bar app dark dense class="bg-dark">
    <template v-if="!$vuetify.breakpoint.xs">
      <v-flex dark>
        <v-tabs hide-slider background-color="#24292e">
          <v-tab @click="page_to('/')" class="tab-active v-tab--active">
            <v-flex shrink pr-3>
              <v-avatar tile size="26" style="margin-bottom:2px">
                <img :src="require('@/assets/logo.png')" alt="CUBIC-Cloud" />
              </v-avatar>
            </v-flex>
            <v-flex shrink>
              <v-toolbar-title class="project_name text-none">
                CUBIC-Cloud
              </v-toolbar-title>
            </v-flex>
          </v-tab>
          <v-tab @click="page_to('/news')" class="tab-active v-tab--active">
            News
          </v-tab>
          <v-tab
            @click="page_to('/docs/home')"
            class="tab-active v-tab--active"
          >
            Docs
          </v-tab>
        </v-tabs>
      </v-flex>
    </template>
    <template v-if="$vuetify.breakpoint.xs">
      <v-flex dark style="flex: none;">
        <v-tabs hide-slider background-color="#24292e">
          <v-tab @click="page_to('/')" class="tab-active">
            <v-flex shrink pr-3>
              <v-avatar size="26" style="margin-bottom:2px">
                <img
                  :src="require('@/assets/logo_CUBICStars.png')"
                  alt="CUBICStars"
                />
              </v-avatar>
            </v-flex>
            <v-flex shrink>
              <v-toolbar-title class="project_name">
                CUBIC-Cloud
              </v-toolbar-title>
            </v-flex>
          </v-tab>
        </v-tabs>
      </v-flex>
      <v-menu
        offset-y
        max-width="200"
        min-width="200"
        v-model="navigationMenu"
        :close-on-content-click="false"
      >
        <template v-slot:activator="{on}">
          <v-app-bar-nav-icon class="ml-3" v-on="on" large></v-app-bar-nav-icon>
        </template>
        <v-list>
          <v-list-item
            link
            @click="
              page_to('/News')
              navigationMenu = false
            "
          >
            <v-list-item-icon class="mr-2">
              <v-icon>mdi-information-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>News</v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="
              page_to('/docs/home')
              navigationMenu = false
            "
          >
            <v-list-item-icon class="mr-2">
              <v-icon>mdi-book-open-page-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Docs</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-spacer></v-spacer>
    </template>
    <template v-if="isLogined">
      <v-menu
        offset-y
        max-width="400"
        min-width="350"
        :close-on-content-click="false"
        v-model="showRecentActivities"
      >
        <template v-slot:activator="{on}">
          <v-btn
            icon
            class="ml-1"
            large
            color="#eee"
            v-on="on"
            @click="reloadRecentActivities"
          >
            <v-icon>mdi-bell</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-list>
            <v-list-item-content class="py-2">
              <v-list-item-title class="text-center" style="color:#666">
                Notice
              </v-list-item-title>
            </v-list-item-content>
          </v-list>
          <v-divider></v-divider>
          <v-list>
            <recent-activities
              :for-notice="true"
              ref="recentActivities"
              class="recent-activities"
            />
          </v-list>
        </v-card>
      </v-menu>
      <v-menu offset-y max-width="350" min-width="350">
        <template v-slot:activator="{on}">
          <v-btn icon class="ml-1" large color="#eee" v-on="on">
            <v-icon>mdi-account-circle</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-list>
            <v-list-item>
              <v-list-item-avatar>
                <v-icon x-large>mdi-account-circle</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  {{ this.userName || 'No Name' }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ this.userInfo.attributes.email || '' }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <v-list>
            <v-list-item link @click="page_to('/account/profile')">
              <v-list-item-icon class="mr-5">
                <v-icon>mdi-account-box-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Account profile</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link @click="page_to('/account/subscription')">
              <v-list-item-icon class="mr-5">
                <v-icon>mdi-star-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Subscription</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="signOut()">Sign out</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </template>
    <template v-else>
      <v-btn @click="page_to('/signin')" text>
        Sign in
      </v-btn>
    </template>
  </v-app-bar>
</template>

<script>
import {mapState, mapMutations, mapGetters} from 'vuex'
import {AmplifyEventBus} from 'aws-amplify-vue'

import {Auth} from 'aws-amplify'
import RecentActivities from '@/components/RecentActivities.vue'

export default {
  components: {
    RecentActivities,
  },
  data: () => ({
    navigationMenu: false,
    showRecentActivities: false,
  }),
  computed: {
    ...mapState({
      header: (state) => state.page.header,
      userInfo: (state) => state.auth.user,
      userName: (state) => state.auth.userProfile.UserName,
    }),
    ...mapGetters({
      isLogined: 'auth/isLogined',
    }),
  },
  methods: {
    ...mapMutations({
      setUser: 'auth/setUser',
      setUserProfile: 'auth/setUserProfile',
    }),
    reloadRecentActivities() {
      if (this.showRecentActivities) {
        // Do nothing when the recent activities is shown.
        return
      }
      if (this.$refs.recentActivities) {
        this.$refs.recentActivities.init()
      }
    },
    async signOut() {
      try {
        await Auth.signOut()
        AmplifyEventBus.$emit('authState', 'signedOut')
      } catch (e) {
        //
      }
    },
  },
}
</script>

<style scoped lang="scss">
.nav-menu-expantion {
  &:before {
    box-shadow: unset !important;
  }
  &-content {
    & > div {
      padding: 0;
    }
  }
  &-header {
    & > .v-expansion-panel-header__icon {
      margin-right: 12px;
    }
  }
}
.icon-docs {
  transition: 0.5s;
  &.is-docs-opened {
    transform: rotate(-180deg);
  }
}
.tab-active {
  color: #e0e0e0 !important;
  opacity: 1 !important;
}
.v-slide-group__prev--disabled {
  display: none !important;
}
.v-toolbar__content {
  padding-left: 0 !important;
  .v-btn:hover:before {
    opacity: 0.24 !important;
  }
}
</style>

<style scoped>
.recent-activities {
  height: 350px; /* or any height you want */
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
